//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'operationBoardDetail',
  data(){
    return {period:'today',dimension:'all',page:0,limit:15,loading:false,busy:false,hasNext:true,errorText:'',list:[],data:{}}
  },
  computed:{
    periodLabel(){ return {today:'今日',yesterday:'昨日',week:'本周',month:'本月',year:'本年'}[this.period] || '今日'; }
  },
  created(){
    var periods=['today','yesterday','week','month','year'];
    var dimensions=['all','stored','discount','package','year','stored_sale','times','mini','offline','douyin'];
    var p=String(this.$route.query.period || 'today');
    var d=String(this.$route.query.dimension || 'all');
    this.period=periods.indexOf(p) >= 0 ? p : 'today';
    this.dimension=dimensions.indexOf(d) >= 0 ? d : 'all';
    this.loadMore();
  },
  methods:{
    reload(){ this.page=0;this.list=[];this.hasNext=true;this.errorText='';this.loadMore(); },
    loadMore(){
      if(this.busy || !this.hasNext) return;
      this.busy=true;this.loading=true;this.errorText='';
      var nextPage=this.page+1;
      this.$api.operationBoardDetail({period:this.period,dimension:this.dimension,page:nextPage,limit:this.limit}).then((res)=>{
        this.busy=false;this.loading=false;
        if(!(res && res.data)){
          if(!this.list.length) this.errorText='明细加载失败';
          return;
        }
        this.data=res.data;
        this.page=nextPage;
        this.list=this.list.concat(Array.isArray(res.data.list) ? res.data.list : []);
        this.hasNext=Number(res.data.hasNext) > 0;
      }).catch(()=>{
        this.busy=false;this.loading=false;
        if(!this.list.length) this.errorText='明细加载失败，请稍后重试';
      });
    },
    backToBoard(){ this.$router.push({name:'operationBoard',query:{period:this.period}}); },
    money(value){ return (Number(value)||0).toLocaleString('zh-CN',{minimumFractionDigits:2,maximumFractionDigits:2}); },
    count(value){ return (Number(value)||0).toLocaleString('zh-CN'); }
  }
}



// WEBPACK FOOTER //
// ./src/pages/operationBoardDetail.vue